module.exports = __webpack_public_path__ + "static/media/favicon.7cdd013f.ico";